var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('modal-overlay', {
    attrs: {
      "open": _vm.open
    }
  }, [_vm.stage === 0 ? _c('disclosure-modal', {
    attrs: {
      "show": _vm.stage === 0,
      "disclosure": "Extra_Debit_Payment_Service"
    },
    on: {
      "close": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "controls",
      fn: function () {
        return [_c('a', {
          attrs: {
            "target": "_blank"
          },
          on: {
            "click": _vm.close
          }
        }, [_vm._v("Skip now")])];
      },
      proxy: true
    }, {
      key: "content",
      fn: function () {
        return [_c('div', {
          staticClass: "mt-8 space-y-5 color--dark--grey"
        }, [_c('div', {
          staticClass: "flex flex-row items-center space-x-5"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.disclosureOption,
            expression: "disclosureOption"
          }],
          attrs: {
            "id": "14_day-input",
            "value": "14_days_ach",
            "type": "radio"
          },
          domProps: {
            "checked": _vm._q(_vm.disclosureOption, "14_days_ach")
          },
          on: {
            "change": function ($event) {
              _vm.disclosureOption = "14_days_ach";
            }
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "!text-sm !leading-normal",
          attrs: {
            "for": "14_day-input"
          }
        }, [_vm._v("I have read and understand the limitation of the 14 day payment option and still want\n\t\t\t\t\t\tto proceed\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
          staticClass: "flex flex-row items-center space-x-5"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.disclosureOption,
            expression: "disclosureOption"
          }],
          attrs: {
            "id": "next_day-input",
            "value": "next_day_ach",
            "type": "radio"
          },
          domProps: {
            "checked": _vm._q(_vm.disclosureOption, "next_day_ach")
          },
          on: {
            "change": function ($event) {
              _vm.disclosureOption = "next_day_ach";
            }
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "!text-sm !leading-normal",
          attrs: {
            "for": "next_day-input"
          }
        }, [_vm._v("I want to continue with the next day ACH payment option to maximize my Extra Card\n\t\t\t\t\t\tusage\n\t\t\t\t\t")])])]), _vm._v(" "), _c('button', {
          staticClass: "mt-16 sm:w-full",
          class: {
            'button--mint': _vm.disclosureOption
          },
          attrs: {
            "disabled": !_vm.disclosureOption
          },
          on: {
            "click": _vm.reviewDisclosureOption
          }
        }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.formFilled === false ? 'Continue' : 'Submit for review') + "\n\t\t\t")])];
      },
      proxy: true
    }], null, false, 639784721)
  }) : _vm.stage === 1 || _vm.stage === 2 ? _c('div', {
    staticClass: "modal-content flex flex-col px-4 py-10 text-center"
  }, [_vm.stage === 1 ? [_c('h3', [_vm._v("Do you still want to switch to 14 day payment option?")]), _vm._v(" "), _c('p', {
    staticClass: "mt-8"
  }, [_vm._v("\n\t\t\t\tThe 14 day payment option limits your usage of the Extra Debit Card to one transaction\n\t\t\t\tevery 14 days, unless you elect to make manual transaction prior.\n\t\t\t\t"), _c('br'), _c('br'), _vm._v("\n\t\t\t\tLonger payment options have a higher default rate and less positive effect on your credit\n\t\t\t\treport.\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button--mint mt-8",
    on: {
      "click": _vm.confirmNextDayPaymentOption
    }
  }, [_vm._v("\n\t\t\t\tStay on next day\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button--mint mt-8",
    on: {
      "click": _vm.completeModalStage1
    }
  }, [_vm._v("\n\t\t\t\tContinue with 14 day payment option\n\t\t\t")])] : _vm.stage === 2 ? [_c('h3', [_vm._v("Are you sure?")]), _vm._v(" "), _c('p', {
    staticClass: "mt-8"
  }, [_vm._v("\n\t\t\t\tYou have to go into the Extra app and manually pay individual transactions to unlock your\n\t\t\t\tcard. If you default on your transactions for more than 90 days, your account will be\n\t\t\t\tclosed and may impact your credit score negatively.\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button--mint mt-8",
    on: {
      "click": _vm.confirmNextDayPaymentOption
    }
  }, [_vm._v("\n\t\t\t\tKeep it next day\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button--mint mt-8",
    on: {
      "click": _vm.confirm14DayPaymentOption
    }
  }, [_vm._v("\n\t\t\t\tI understand and would like to proceed\n\t\t\t")])] : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "cursor-pointer box-content absolute top-0 right-0 p-4",
    attrs: {
      "src": require("assets/images/close.svg"),
      "width": "14px",
      "height": "14px",
      "draggable": "false"
    },
    on: {
      "click": _vm.backToDisclosure
    }
  })], 2) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };